import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from '../../theme';
import {
  PieChartIcon,
  TableChartIcon,
  ShowChartIcon,
  CloudIcon
} from '../customStyles/images';

const iconType = {
  "pieChart": { icon: <PieChartIcon variant='lg_100' style={{ transform: 'rotate(30deg)' }} /> },
  "tableChart": { icon: <TableChartIcon variant='lg_100' /> },
  "cloud": { icon: <CloudIcon variant='lg_100' /> },
  "showChart": { icon: <ShowChartIcon variant='lg_100' /> },
}

const NoData = ({ size, type }) => {

  return (
    <Box
      sx={{
        textAlign: 'center',
        alignContent: 'center',
        height: size === "large" ? '33vh' : '30vh',
        color: theme.palette.grey.w200
      }}>
      {iconType[type].icon}
      <Typography>無資料</Typography>
    </Box>
  )
}

export default NoData;